<template>
  <main-content>
    <div class="tab-content">
      <div v-if="current_user.permissions.length > 0" id="user-list" class="tab-pane active">
        <notification-filter :action="filterAction"></notification-filter>
        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
      </div>
    </div>
  </main-content>
</template>

<script>
import $ from "jquery";
import mainContent from "@/components/main-content";
import {mapGetters} from "vuex";
import columns from "./datatable/columns";
import {ApiUrl, openBankingService, transactionService, userService} from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";
import {actionsColumn, notificationFilter} from "./components";
import axios from "axios";
import {KTApp} from '@/plugins/core/app'
import {i18n} from "@/plugins/i18n";

// import { KTUtil } from '@/plugins/core/app'
export default {
  components: {
    mainContent,
    notificationFilter
  },

  data() {
    return {
      headerAction: {
        left: "10px",
        top: "10px",
        position: "absolute",
      },
      per_page: 15,
      query: {newsid: 2},
    };
  },
  computed: {
    ...mapGetters('user', [
      'current_user'
    ]),
    datatableProps() {
      console.log( this.$can('read-sensitive-data', 'notification') );
      return {
        id: "user_datatable",
        data: {
          type: "remote",
          source: {
            read: {
              url: ApiUrl.path("notifications"),
              method: "GET",
              headers: AuthorizationHeader,
              map: function (res) {
                return res.data.data;
              },
              params: {
                ...this.query,
              },
            },
          },
          pageSize: 10,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
        },
        layout: {},
        pagination: false,
        sortable: true,
        columns: columns,
        actions: this.$can('read-sensitive-data', 'notification') ? actionsColumn : null,
      };
    },
  },
  methods: {
    filterAction(e, query) {
      this.query = query;
      if (this.$refs.datatable.KTDatatable) {
        this.$refs.datatable.reload();
      }
    },
    checkFormValidate(form) {
      let validator = form.validate();
      if (!this.checkValidatePhone(this.new_user.phone)) {
        validator.showErrors({
          phone: i18n.t('pos.validations.phone_number')
        })
        return false;
      }
      if (!this.checkIfIsPersian(this.new_user.first_name)) {
        validator.showErrors({
          first_name: i18n.t('pos.validations.enter_persian')
        })

        return false;
      }
      if (!this.checkIfIsPersian(this.new_user.last_name)) {
        validator.showErrors({
          last_name: i18n.t('pos.validations.enter_persian')
        })
        return false;
      }
      return true;
    }

  },
};
</script>

<style>
</style>
